namespace AgerLMS.Coaching {
    export interface UserCurrentStateRow {
        Id?: number;
        StudyTrackingId?: number;
        LessonId?: number;
        CurrentNet?: number;
        TargetNet?: number;
        RemainingTarget?: number;
        TargetWork?: number;
        UserWorkTime?: number;
        WorkPercent?: number;
        LessonName?: string;
        LessonQuestionCount?: number;
        LessonGroups?: LessonGroups;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace UserCurrentStateRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Coaching.UserCurrentState';
        export const deletePermission = 'Coaching:UserCurrentState:Modify';
        export const insertPermission = 'Coaching:UserCurrentState:Modify';
        export const readPermission = 'Coaching:UserCurrentState:Read';
        export const updatePermission = 'Coaching:UserCurrentState:Modify';

        export declare const enum Fields {
            Id = "Id",
            StudyTrackingId = "StudyTrackingId",
            LessonId = "LessonId",
            CurrentNet = "CurrentNet",
            TargetNet = "TargetNet",
            RemainingTarget = "RemainingTarget",
            TargetWork = "TargetWork",
            UserWorkTime = "UserWorkTime",
            WorkPercent = "WorkPercent",
            LessonName = "LessonName",
            LessonQuestionCount = "LessonQuestionCount",
            LessonGroups = "LessonGroups",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
